import { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../context/authProvider'
import { isMobileApp } from '../utils/mobileAppFunctionality'

// The issue is that the mobile app sends the token and
// authenticates the user while the page is already rendered
const useUpdateMobileAppToken = (initSportsbookSettings) => {
  const { isLoggedIn } = useContext(AuthContext)
  const [wasLoggedIn, setWasLoggedIn] = useState(null)

  const updateSportsToken = () => {
    if (isLoggedIn === wasLoggedIn || !isMobileApp()) return
    if (wasLoggedIn !== null) initSportsbookSettings()

    setWasLoggedIn(isLoggedIn)
  }

  useEffect(() => {
    updateSportsToken()
  }, [isLoggedIn])
}

export default useUpdateMobileAppToken
